import { API_URL } from '@/config';
import { getCurrentLanguage } from '@/lib/i18n/getCurrentLanguage';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: `${API_URL}/api/v1/graphql`,
  credentials: 'include',
});

const langLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'Accept-Language': getCurrentLanguage(),
    },
  };
});

export const apolloClient = new ApolloClient({
  link: langLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      ActiveArticle: {
        keyFields: ['code'],
      },
      DeletedArticle: {
        keyFields: ['code'],
      },
    },
  }),
});
